module.exports = global["$"] = require("-!c:\\jenkins\\workspace\\_classic_ownerportal_development\\Solutions\\op\\Owner.Portal\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 40
// module chunks = 0